<div class="p-support-info">
  <div class="p-support-info__head">
    <h2 class="p-support-info__head-title" [innerHTML]="'label.walking.ability' | staticMsg"></h2>
  </div>
  <div class="p-support-info__body">
    <div class="p-support-info__item">
      <div class="p-support-info__row">
        <fieldset class="p-support-info__radio" role="radiogroup" aria-invalid="false">
          <legend class="p-support-info__radio-legend" [innerHTML]="'label.walking.ability' | staticMsg"></legend>
          <div class="p-support-info__radio-list">
            <!-- [14.9] 歩行の程度 -->
            <div *ngFor="let item of master; index as idx" class="p-support-info__radio-item">
              <input
                type="radio"
                name="radio1"
                id="radio1_{{ idx + 1 }}"
                class="p-support-info__radio-item-input"
                [checked]="code === item.value"
                (change)="changeCode(item.value)"
              />
              <label for="radio1_{{ idx + 1 }}" class="p-support-info__radio-item-label">
                <span class="p-support-info__radio-item-check"></span>
                <span class="p-support-info__radio-item-text-wrap">
                  <span class="p-support-info__radio-item-text" [innerHTML]="item.display_content"></span>
                </span>
              </label>
            </div>
          </div>
        </fieldset>
        <asw-validation-error
          *ngIf="error !== null"
          id="{{ id }}_radio-error"
          [errorMessage]="error"
        ></asw-validation-error>
      </div>
    </div>
  </div>
</div>
